<div class="button-group" >
    <button class="whitespace-nowrap rounded border border-r-0 border-form-control bg-form-control text-sm leading-4 hover:bg-button-hover" 
    type="button" (click)="openNotificationDetail(data.ID)">
        <span>{{ 'Detail' | translate }}</span>
    </button>
    <button class="rounded border border-form-control bg-form-control hover:bg-button-hover" type="button" #saveAnchor>
        <bizz-toggle-arrow class="h-4 w-4" [direction]="isMenuOpen ? 'up' : 'down'"></bizz-toggle-arrow>
    </button>
</div>
<kendo-contextmenu
    size="small" showOn="click" 
    (popupOpen)="isMenuOpen = true"
    (popupClose)="isMenuOpen = false"
    [target]="saveAnchor"
    #saveContextMenu
    [anchorAlign]="popupAnchorAlign"
    [alignToAnchor]="true" #menu>
    <ng-template kendoContextMenuTemplate>  
        <button class="text-xs font-medium text-default hover:text-blue-500">
            @if (data['Read']) {
                <span (click)="unreadNotification()">{{ 'MarkAsUnread' | translate }}</span>
            }
            @if (!data['Read']) {
                <span  (click)="readNotification()">{{ 'MarkAsRead' | translate }}</span>
            }
        </button>
    </ng-template>
</kendo-contextmenu>
